import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import Layout from "./components/Layout";
import ProtectedRoute from "./components/ProtectedRoute";
import { Toaster } from "./components/ui/sonner";

import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import FpoDashboard from "./pages/FpoDashboard";
import BatchDetails from "./pages/BatchDetails";
import BuyerDashboard from "./pages/BuyerDashboard";
import AdminDashboard from "./pages/AdminDashboard";
import VerifyBatch from "./pages/VerifyBatch";

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/verify/:batchId" element={<VerifyBatch />} />
            <Route path="/fpo" element={
              <ProtectedRoute roles={["fpo"]}><FpoDashboard /></ProtectedRoute>
            }/>
            <Route path="/fpo/batch/:batchId" element={
              <ProtectedRoute roles={["fpo"]}><BatchDetails /></ProtectedRoute>
            }/>
            <Route path="/buyer" element={
              <ProtectedRoute roles={["buyer"]}><BuyerDashboard /></ProtectedRoute>
            }/>
            <Route path="/admin" element={
              <ProtectedRoute roles={["admin"]}><AdminDashboard /></ProtectedRoute>
            }/>
          </Routes>
        </Layout>
        <Toaster richColors position="top-right" />
      </BrowserRouter>
    </AuthProvider>
  );
}
